
import { defineComponent } from "vue";
import NamedSection from "../publisher/NamedSection.vue";
import DeveloperProfileSection from "./DeveloperProfileSection.vue";

export default defineComponent({
    components: {
        NamedSection,
        DeveloperProfileSection,
    },
    props: {
        aboutDeveloper: {
            type: String,
            required: false,
        },
        editing: {
            type: Boolean,
            required: true,
        },
        aboutDeveloperPrevious: {
            type: String,
            required: false,
        },
    },
    computed: {
        aboutDeveloperValue: {
            get() {
                return this.$props.aboutDeveloper;
            },
            set(value: string) {
                this.$emit("update:aboutDeveloper", value);
            },
        },
    },
    data() {
        return {
            validationRules: [
                (text: string): string | boolean => !!text || "Required",
                (text: string): string | boolean => text.length <= 150 || "Maximum 150 characters",
            ],
        };
    },
});
